import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonalDetailComponent } from './personal-detail.component';

import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { ModalModule } from 'ngx-bootstrap/modal';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MatRadioModule } from '@angular/material/radio';

// ----- Material ----- //
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FormFieldInputModule, FormFieldPasswordModule, FormFieldSelectModule, FormFieldInputMaskModule, FormFieldDateModule, ButtonsModule } from '@app/shared';


@NgModule({
  declarations: [
    PersonalDetailComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    MatStepperModule,
    MatSelectModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatInputModule,
    FormFieldInputModule,
    FormFieldPasswordModule,
    FormFieldSelectModule,
    FormFieldInputMaskModule,
    FormFieldDateModule,
    ButtonsModule,
    MatRadioModule,
    ModalModule.forRoot(),
    NgMultiSelectDropDownModule
  ],
  exports: [
    PersonalDetailComponent
  ]
})
export class PersonalDetailModule { }
